import classes from './Summary.module.css'

const Summary = () => {
    return (
      <section className={classes.summary}>
      <h2>
     
  <span>Hi Im Ali    its been 1 year &nbsp; </span>
  <span>  Working &nbsp;through Front End </span>

  <span>Development&nbsp;</span>
  <span>Focusing on&nbsp;</span>
  <span>JavaScript & React&nbsp;</span>
  <span>always Pushing to Research&nbsp; </span>
  <span>and Develop New feauters imporving&nbsp;</span>
  <span> Skills and Experience &nbsp;</span>
  <span>like Declarative Codes ,&nbsp;</span>
  <span>Tools and Packages&nbsp;</span>
  <span>and challengs to &nbsp;</span>
  <span>take as a Developer&nbsp;</span>
  
</h2>
      </section>
    );
  };
  
  export default Summary;
 
